module.exports = __webpack_public_path__ + "img/9.64b16358.jpg";